import { render } from "./SocialMedia.vue?vue&type=template&id=031f4e84"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"

import "./SocialMedia.vue?vue&type=style&index=0&id=031f4e84&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__